import gsap from 'gsap';
import Order from './order';
import Utils from '../../assets/scripts/utils/utils';

class OrderPayment {
	constructor(el) {
		this.container = el;
		this.methods = this.container.querySelectorAll('.order-payment__method');
		this.yaSplit = this.container.querySelector('.order-payment__ya-split');

		if (!this.container || this.inited) return;

		this.init();
		this.inited = true;
		this.container.orderPayment = this;
	}

	init() {
		this._initBonus();
		this._initValidation();

		this.methodRadios = this.container.querySelectorAll('.order-payment__method input');
		this.deliveryRadios = document.querySelectorAll('.order-delivery__list input[type="radio"]');

		this.deliveryRadios.forEach((radio) => {
			radio.addEventListener('change', () => this._handleDeliveryChange());
		});

		this.methodRadios.forEach((radio) => {
			radio.addEventListener('change', (evt) => this._handleMethodChange(evt));
		});
	}

	_initBonus() {
		this.bonusCheckbox = this.container.querySelector('.checkbox._bonus input');

		if (!this.bonusCheckbox || this.bonusCheckbox.inited) return;

		this.bonusCheckbox?.addEventListener('change', () => this._handleBonusCheckboxChange());
		this._handleBonusCheckboxChange(true);
		this.bonusCheckbox.inited = true;
	}

	_handleBonusCheckboxChange(immediate) {
		const bonusSection = this.container.querySelector('.order-payment__bonus');
		const splitRadio = this.container.querySelector('#split');
		const certRadio = this.container.querySelector('#certificate');
		const bonusInput = document.querySelector('#bonus-points');
		const duration = immediate ? 0 : 0.35;
		const isChecked = this.bonusCheckbox.checked;

		gsap.to(bonusSection, {
			height: this.bonusCheckbox.checked ? 'auto' : 0,
			duration,
		});

		if (splitRadio) {
			splitRadio.disabled = isChecked;
		}

		if (certRadio) {
			certRadio.disabled = isChecked;
		}

		if (splitRadio && splitRadio.disabled && splitRadio.checked) {
			this.methodRadios[0].checked = true;
			splitRadio.dispatchEvent(new Event('change'));
		}

		if (certRadio && certRadio.disabled && certRadio.checked) {
			this.methodRadios[0].checked = true;
			certRadio.dispatchEvent(new Event('change'));
		}

		if (isChecked) {
			const maxValue = Number(bonusInput.getAttribute('data-max-value')) || 0;

			bonusInput.value = maxValue;
			bonusInput.touched = true;
			bonusInput.customInput.container.classList.toggle('_touched', true);
			bonusInput.setAttribute('data-touched', true);
		}
	}

	_handleMethodChange(evt) {
		const input = evt.target;
		const splitSection = this.container.querySelector('.order-payment__split');

		gsap.to(splitSection, {
			height: input.checked && input.id === 'split' ? 'auto' : 0,
			duration: 0.35,
		});

		if (!this.bonusCheckbox) {
			return;
		}

		if (input.checked && (input.id === 'split' || input.id === 'certificate')) {
			this.bonusCheckbox.checked = false;
			this.bonusCheckbox.dispatchEvent(new Event('change'));
			this.bonusCheckbox.disabled = true;
		} else {
			this.bonusCheckbox.disabled = false;
		}
	}

	_handleDeliveryChange() {
		if (!this.bonusCheckbox) {
			return;
		}

		this.bonusCheckbox.disabled = false;
	}

	_initValidation() {
		const footerCheckboxes = this.container.querySelectorAll('.order-payment__footer-options input');
		const submitButton = this.container.querySelector('[type="submit"]');

		submitButton?.addEventListener('click', () => {
			const isPrivacyChecked = footerCheckboxes[0].checked;

			submitButton.disabled = !isPrivacyChecked;

			footerCheckboxes.forEach((checkbox) => {
				checkbox.closest('.checkbox').classList.toggle('_error', !isPrivacyChecked);
			});
		});

		footerCheckboxes[0]?.addEventListener('change', (evt) => {
			const input = evt.target;
			const isChecked = input.checked;

			if (isChecked) {
				input.closest('.checkbox').classList.remove('_error');
				submitButton.disabled = false;
			}
		});
	}
}

document.querySelectorAll('[data-order-payment]').forEach((el) => new OrderPayment(el));
export default OrderPayment;
